module.exports = __webpack_public_path__ + "static/media/Maison-Common-Summer-2019-5419.52dadfaf.jpg";